import React from 'react';

const UserTopRepositories = ({ user }) => {
  if (!user.repositories?.nodes?.length) return null;
  return (
    <div className="mt-2">
      <strong>Top Repositories:</strong>
      <ul className="small m-0">
        {user.repositories.nodes.map((repo) => (
          <li key={repo.name}>
            <a href={`https://github.com/${user.login}/${repo.name}`} target="_blank" rel="noopener noreferrer">
              {repo.name}
            </a>{' '}
            ({repo.primaryLanguage?.name || 'Unknown'} | ⭐ {repo.stargazerCount})
          </li>
        ))}
      </ul>
      <div className="text-muted">{user.email}</div>
    </div>
  );
};

export default UserTopRepositories;
